export default __webpack_public_path__ + "assets/133e1a6639d3bc76d4a10834bc38fd91.svg";